import { http } from '../../axios';
import { localContentPrefix } from '../../../config';

const url = `${localContentPrefix}/v1/localcontent/performers/:performerId`;
export function deletePerformer(performerId: string) {
    const params = { pathParams: { performerId } };
    return http.delete(url, params);
}
